<ces-asset-breadcrumb [trail]="nav.breadcrumbTrail()" />

<div class="px-(--space-4)">
  @if (model(); as model) {
    <ces-route-title [title]="model.name">
      @if (planningGrid(); as grid) {
        @if (!grid.isLoading()) {
          <span class="self-center text-sm text-(color:--text-secondary)">
            {{ 'common.planning.plannedCount' | transloco: { count: grid.plannedCount() } }}
          </span>
        }
        @if (canWriteAsset()) {
          <ces-button
            [label]="'common.buttons.plan' | transloco"
            [ariaLabel]="'common.buttons.plan' | transloco"
            icon="event"
            [disabled]="grid.isLoading() || grid.isSaving()"
            (onClick)="openPlanningDialog()" />
        }
      }
      @if (menuItems().length > 0) {
        <ces-menu-button-secondary
          [hasPermission]="{ method: 'putCampaignModelDetailResource', assetId: currentAssetId() ?? undefined }"
          icon="more_vert"
          [ariaLabel]="'common.accessibility.openMenu' | transloco"
          [items]="menuItems()" />
      }
    </ces-route-title>
  }

  <p-tabs [value]="activeIndex()">
    <p-tablist>
      <p-tab [value]="0" (click)="onTabChange(0)">{{ 'entities.campaign.tabs.measures' | transloco }}</p-tab>
      <p-tab [value]="1" (click)="onTabChange(1)">{{ 'entities.campaign.tabs.auscultation' | transloco }}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        @if (activeIndex() === 0) {
          <router-outlet (activate)="onTabActivate($event)" (deactivate)="onTabDeactivate()" />
        }
      </p-tabpanel>
      <p-tabpanel [value]="1">
        @if (activeIndex() === 1) {
          <router-outlet (activate)="onTabActivate($event)" (deactivate)="onTabDeactivate()" />
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
